<template>
  <div
    class="flex-shrink-0 align-middle content-center leading-snug"
    :class="{ 'box-title-l-1': lines == 1, 'box-title-l-2': lines == 2 }"
  >
    <h1
      class="text-chplus-title-color-l"
      :class="{
        'text-color-white': color == 'white',
        'text-chplus-blue-gradient': color == 'blue'
      }"
    >
      <slot></slot>
    </h1>
  </div>
</template>

<script>
export default {
  name: "BoxTitleL",
  props: {
    color: {
      type: String,
      default: "blue",
      validator: function(value) {
        // The value must match one of these strings
        return ["white", "blue"].includes(value);
      }
    },
    lines: {
      type: Number,
      default: 1,
      validator: function(value) {
        // The value must match one of these strings
        return [1, 2].includes(value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.box-title-l-1 {
  min-height: 3.864rem;
}

.box-title-l-2 {
  min-height: 7.392rem;
}

@media (min-width: 768px) {
  .box-title-l-1 {
    min-height: 4.416rem;
  }
  .box-title-l-2 {
    min-height: 8.448rem;
  }
}
</style>
